import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
		maxWidth: '60rem',
		marginTop: theme.spacing(3),
	},
	formGroup: {
		marginBottom: theme.spacing(5),
	},
	tcHeader: {
		marginBottom: theme.spacing(2),
	},
}));
